import {useClient, useDictionary} from '@adamlip/okeoke.client';
import {Radio, RadioGroup} from '@heroui/react';
import {useEffect, useState} from 'react';
import SendVibration from 'utils/Helpers-v1/SendVibration';

function SizeSelector({sizes, setSize, selectedSizeUUID}) {
	const {getName} = useClient();
	const [sizeArray, setSizeArray] = useState([]);
	const {getValue} = useDictionary();
	const handleClickOnSize = (sizeUUID) => {
		SendVibration('light');

		setSize(sizeUUID);
	};

	useEffect(() => {
		const visibleSizes = sizes.filter((size) => size?.availability?.visible === 1);
		setSizeArray(visibleSizes);
		if (visibleSizes?.length === 1) {
			setSize(visibleSizes[0].uuid);
		}
		//eslint-disable-next-line
	}, [sizes]);

	if (sizeArray?.length < 2) return null;
	return (
		<div className='flex flex-col gap-2 rounded-general border border-border p-2'>
			<div className='w-full flex flex-row gap-2 items-center justify-between text-sm'>
				<div className='opacity-70 '>{getValue('app_v2_item_sizeSelector')}</div>
				<div className='opacity-70 '>*{getValue('app_v2_item_chose_one')}</div>
			</div>
			<RadioGroup value={selectedSizeUUID} onValueChange={handleClickOnSize} className='w-full'>
				{sizeArray
					?.sort((a, b) => (a?.idx > b?.idx ? 1 : -1))
					?.map((size) => {
						return (
							<Radio
								key={size?.uuid}
								value={size?.uuid}
								className={`w-full max-w-full`}
								color={selectedSizeUUID === size?.uuid ? 'primary' : 'default'}
								classNames={{
									label: 'w-full ',
									base: 'flex-row-reverse gap-2',
									labelWrapper: 'w-full',
								}}>
								<div className='flex flex-row gap-2 items-center justify-between w-full'>
									<div className='text-lg font-medium grow'>{getName(size?.name)}</div>

									<div className={`text-sm text-right ${selectedSizeUUID === size?.uuid ? 'text-current' : 'text-primary'} `}>{size?.price != null ? size?.price + ' Ft' : ''}</div>
								</div>
							</Radio>
						);
					})}
			</RadioGroup>
		</div>
	);
}

export default SizeSelector;
